<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>
<div>
	<!-- delete confirmation dialog from common package -->
	<res-confirmation-dialog></res-confirmation-dialog>

	<his-search-result #SearchResultComponent
					   [showTitle]="true"
					   [showNewSearchButton]="true"
					   jobStarterKey="fs.res.search-researchInfrastructure-reports"
					   defaultActionRoute="/researchInfrastructure/view/:id"
					   idColumn="ResearchInfrastructure.id"
					   defaultColumn="ResearchInfrastructure.title"
					   [searchConfigFile]="moduleOptions.SEARCH_CONFIGURATION_FILENAME">>

	    <ng-container *ngIf="showBackButton" customResultButtons>
            <button (click)="navigationService.navigateToLastBackUrl()"> {{'common.back' | hisUi }} </button>
        </ng-container>

		<ng-template #rowAction let-row="row">
			<!-- edit "button": disabling needs some trickery because links do not support the disabled attribute -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_EDIT)">
				<a *ngIf="row.get('canEdit')" (click)="onBeforeNavigate()" routerLink="/researchInfrastructure/edit/{{row.get('ResearchInfrastructure.id')}}" [queryParams]="{showBackButton: showBackButton, showSearchButton: true}"
				    hisImage="pencil" title="{{'common.editOf'|hisUi:row.get('ResearchInfrastructure.title')}}"></a>
				<img *ngIf="!row.get('canEdit')" hisImage="pencil_i" class="inlineicon imggrey"
				    title="{{'common.editOf'|hisUi:row.get('ResearchInfrastructure.title')}}">
			</ng-container>

            <!-- detail view -->
            <a routerLink="/researchInfrastructure/view/{{row.get('ResearchInfrastructure.id')}}" (click)="onBeforeNavigate()" [queryParams]="{showSearchButton: true,showBackButton: showBackButton}"
            hisImage="magnifier_detail" title="{{'common.showOf'|hisUi:row.get('ResearchInfrastructure.title')}}"></a>

			<!-- delete button -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_DELETE)">
                <img hisImage="hyphen" class="inlineicon treeAction hyphen">

				<button (click)="deleteRow(row)" hisImage="delete" class="icon" [disabled]="!row.get('canDelete')"
				    title="{{'common.deleteOf'|hisUi:row.get('ResearchInfrastructure.title')}}"></button>
			</ng-container>
		</ng-template>
	</his-search-result>
	<br />

	<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE)">
		{{'fs.res.researchInfrastructure.ResearchInfrastructure.search.notFoundQuestion'| hisUi}}<br />
		<a routerLink="/researchInfrastructure/create" hisImage="context_add">{{'fs.res.researchInfrastructure.ResearchInfrastructure.search.create' | hisUi}}</a>
	</ng-container>
</div>
